<template>
  <div data-debug="windowDimensions">
    <ul>
      <li>
        width: {{window.width}}
      </li>
      <li>
        height: {{window.height}}
      </li>
      <li>
        w/h: {{ratioWH}}
      </li>
      <li>
        h/w: {{ratioHW}}
      </li>
    </ul>  
  </div>  
</template>

<script>
export default {
  name: 'debug_windowDimensions',
  props: ['window'],
  computed: {
    ratioWH: function() {
      return (this.window.width / this.window.height).toFixed(2);
    },
    ratioHW: function() {
      return (this.window.height / this.window.width).toFixed(2);
    },
  },
};
</script>

<style lang="scss">
[data-debug="windowDimensions"] {
  position: fixed;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.75);

  ul {
    list-style: none;
    display: flex;
    margin: 0;
    padding: 0;
  }

  li {
    margin: 0 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/debug/windowDimensions.vue